import { Col, Row } from "reactstrap";
import { HORIZONTAL_ALIGNMENT } from "../../../../Data/UiKit/Grid";

export const DynamicHorizontalAlignment = () => {
  return (
    <>
      {HORIZONTAL_ALIGNMENT.map((item, index) => (
        <Row className={`${item} bg-light`} key={index}>
          <Col xs="5"><span className="bg-white text-dark">One column</span></Col>
          <Col xs="5"><span className="bg-white text-dark">Two column</span></Col>
        </Row>
      ))}
    </>
  );
};
